import { MuiButton } from '@/components/button/MuiButton';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { SearchAppHomeType } from '@/schemas/SearchAppHomeSchema';
import { InputAdornment } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type Props = {
  search: () => void;
};

export function InputZipcode({ search }: Props) {
  const { control, setValue } = useFormContext<SearchAppHomeType>();

  return (
    <>
      <MuiTextField
        color="primary"
        name={control.register('zipcode').name}
        control={control}
        placeholder="郵便番号を入力"
        sx={{
          backgroundColor: '#FAFAFA',
          borderRadius: '40px',
          width: '180px',
          '@media (max-width: 600px)': {
            flex: 1,
            width: 'auto',
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderRadius: '40px',
              borderColor: '#FFF',
            },
            '&:hover fieldset': {
              borderRadius: '40px',
              borderWidth: '2px',
              borderColor: '#3ec9be',
            },
          },
        }}
        InputProps={{
          startAdornment: <InputAdornment position="start">〒</InputAdornment>,
        }}
      />
      <MuiButton
        size="large"
        onClick={() => {
          setValue('page', 1);
          search();
        }}
      >
        検索
      </MuiButton>
    </>
  );
}
